import RoutingMixin from './routing-mixin'
import Route from '../../../services/route'
import {secondsFormatShort} from '../../../filters/date'

export default {
  mixins: [RoutingMixin],
  data(){
    return {
      loading: undefined,
      route: {version: 0, name: "Nome da Rota", routeId: undefined, flexField1: undefined},
      editName: false,
      newName: undefined,
      editTime: false,
      newTime: undefined,
      routeStatus: true,
      msg: undefined,
      msgClass: undefined,
      canSave: false
    }
  },
  mounted(){
    let vm = this;
  },
  methods: {

    afterInit(){
      if(this.$route.params.routeId > 0){
        if(this.$store.state.routes){
          this.route = this.$store.getters.getRouteById(this.$route.params.routeId, this.$route.params.version);
          this.populateRoute();
        } else {
          this.$store.dispatch('getRoutes').then(resp => {
            this.route = this.$store.getters.getRouteById(this.$route.params.routeId, this.$route.params.version);
            this.populateRoute()
          });
        }
      }

    },

    populateRoute(){
      this.viaPoints = [];
      this.locationPoints = [];
      let i = 0;
      _.orderBy(this.route.points, ['sequence']).forEach((o) => {
        if(o.type=="viapoint")
          this.viaPoints.push(o);
        else
          this.locationPoints.push(o);
      });
      this.routeStatus = this.route.status.statusId == 1;

      this.$nextTick( () => {
        this.calculate();
      })

    },

    createRoute(successMsg){

      this.msgError = this.msg = undefined;
      
      _.each(this.$refs.ac, function(o){
        o.validate();
      });

      if(!this.route.allCovered){
        this.msgError = 'Não é possivel salvar a rota, pois existem pedágios não atendidos pela Move Mais';
        return;
      }

      let r = this.route;
      r.version += 1;
      r.totalDistance = this.result.totalDistance,
      r.totalTime = this.result.totalTime,
      r.totaltollFeeCost = this.result.totaltollFeeCost;
      r.status = {status: this.routeStatus ? 'ATIVA' : 'INATIVA', statusId: this.routeStatus ? 1 : 2};
      r.points = this.locationPoints;
      r.tollFees = [];
      r.description = this.directionsDisplay.getDirections().routes[0].overview_polyline;

      _.each(this.result.tolls, (o) => {
        
        if(o.associateId > 0){
          r.tollFees.push({
            associateId: o.associateId,
            entryId: o.entryId,
            tollFeeId: o.id,
            name: o.description,
            direction: o.direction,
            address: o.description,
            concession: o.associateId,
            state: o.state,
            pricePerAxle: o.price,
            tollSequence: o.sequence,
            point: {
              lat: o.lat,
              lng: o.lng
            }
          });
        }
      });

      // Verificando o numero de praças de pedágios
      if(r.tollFees.length === 0) {
        this.msgError = 'Não é possivel salvar, pois, não há nenhum pedágio para rota informada.';
        return;
      }
      /*
      let seq = 1;
      r.pointList.pointLocation.push(this.placeToPointLocation(this.originAc.getPlace(), seq++, 'origin'));
      for(var i=0; i<this.wayPoints.length; i++){
        r.pointList.pointLocation.push(this.placeToPointLocation(this.wayPoints[i].getPlace(), seq++, 'waypoint'));
      }
      */
      let seq = this.locationPoints.length + 1;
      let waysReq = this.directionsDisplay.getDirections().request.waypoints || [];
      for(var i=0; i<waysReq.length; i++){
        
        
        if(waysReq[i].stopover === false){
          let latlng = {};
          if(waysReq[i].location && waysReq[i].location.location)
            latlng = {lat: waysReq[i].location.location.lat(), lng: waysReq[i].location.location.lng()};
          else
            latlng = {lat: waysReq[i].location.lat(), lng: waysReq[i].location.lng()};

          r.points.push({state: 'ND', city: 'ND', address: latlng.lat + "," + latlng.lng, sequence: seq++ , type: 'viapoint'});
        }
      }

      
      this.loading = Route.createRoute(r).then(res => {
        
        if(res.status.code == 0) {
          this.msgClass = 'alert-success';
          this.msg = successMsg || res.status.message;
          this.$set(this.route, 'routeId', res.routeId);
          this.$set(this.route, 'version', res.version);
          this.$router.push({name: 'routes'});
        } else {
          this.msgClass = 'alert-danger';
          this.msg = res.data.status.message;
        }
      }).catch(res => {
        this.msgClass = 'alert-danger';
        this.msg = res.data.status && res.data.status.message || 'Erro, favor tentar novamente';
      });
    },

    ativar(){
      this.routeStatus = true;
      this.createRoute('Rota ativada com sucesso');
    },
    desativar(){
      this.routeStatus = false;
      this.createRoute('Rota desativada com sucesso');
    },

    startEditName(){
      this.editName = true;
      this.newName = this.route.name;
      $('[data-toggle="tooltip"]').tooltip('hide');
    },
    cancelEditName(){
      this.editName = false;
      this.newName = undefined;
      $('[data-toggle="tooltip"]').tooltip('hide');
    },
    confirmEditName(){
      if(!this.newName)
        return ;
      this.editName = false;
      this.route.name = this.newName;
      this.newName = undefined;
      $('[data-toggle="tooltip"]').tooltip('hide');
    },
    startEditTime(){
      this.editTime = true;
      this.newTime = secondsFormatShort(this.route.totalTime);
      $('[data-toggle="tooltip"]').tooltip('hide');
    },
    cancelEditTime(){
      this.editTime = false;
      this.newTime = undefined;
      $('[data-toggle="tooltip"]').tooltip('hide');
    },
    confirmEditTime(){
      if(this.newTime.length != 8){
        return
      }
      this.editTime = false;
      let h = this.newTime.split(':');
      
      this.route.totalTime = parseInt(h[0])*86400 + parseInt(h[1])*3600 + parseInt(h[2])*60;
      this.newTime = undefined;
      $('[data-toggle="tooltip"]').tooltip('hide');
    },
    afterUpdateDirections(){
      this.msgError = this.msg = undefined;
      let r = this.route;
      this.$set(r, 'totalDistance', this.result.totalDistance);
      this.$set(r, 'totalTime', this.result.totalTime);
      this.$set(r, 'totaltollFeeCost', this.result.totaltollFeeCost);
      this.$set(r, 'tollFees', []);
      this.$set(r, 'allCovered', this.result.allCovered);

      _.each(this.result.tolls, (o) => {
        
        if(o.associateId > 0){
          r.tollFees.push({
            tollFeeId: o.id,
            name: o.description,
            direction: o.direction,
            address: o.description,
            concession: o.associateId,
            state: o.state,
            pricePerAxle: o.price,
            point: {
              lat: o.lat,
              lng: o.lng
            }
          });
        }
      });

      this.canSave = true;

    },
    placeChanged(){
      this.canSave = false;
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/account/routing/route-detail.js